"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignmentCacheFactory = void 0;
const configuration_factory_1 = require("../configuration-factory");
const chrome_storage_assignment_cache_1 = require("./chrome-storage-assignment-cache");
const hybrid_assignment_cache_1 = require("./hybrid-assignment-cache");
const local_storage_assignment_cache_1 = require("./local-storage-assignment-cache");
const simple_assignment_cache_1 = require("./simple-assignment-cache");
function assignmentCacheFactory({ forceMemoryOnly = false, chromeStorage, storageKeySuffix, }) {
    const simpleCache = new simple_assignment_cache_1.default();
    if (forceMemoryOnly) {
        return simpleCache;
    }
    if (chromeStorage) {
        const chromeStorageCache = new chrome_storage_assignment_cache_1.default(chromeStorage);
        return new hybrid_assignment_cache_1.default(simpleCache, chromeStorageCache);
    }
    else {
        if ((0, configuration_factory_1.hasWindowLocalStorage)()) {
            const localStorageCache = new local_storage_assignment_cache_1.LocalStorageAssignmentCache(storageKeySuffix);
            return new hybrid_assignment_cache_1.default(simpleCache, localStorageCache);
        }
        else {
            return simpleCache;
        }
    }
}
exports.assignmentCacheFactory = assignmentCacheFactory;
//# sourceMappingURL=assignment-cache-factory.js.map